import { tap } from 'rxjs/operators';
import { ConfigService } from '@oneeducation/app-core';
import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigLoaderService {
  private readonly httpBackend = inject(HttpBackend);
  private readonly configService = inject(ConfigService);

  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(this.httpBackend);
  }

  async initialize() {
    const salt = new Date().getTime();
    await this.httpClient
      .get(`assets/config/config.json?ts=${salt}`)
      .pipe(
        tap((response: any) => {
          this.configService.setConfigSettings(response);
        })
      )
      .toPromise();
  }
}
